export function drawPoints(map, points = [], options = {}) {
  const { interactive = true, carIconSrc = '', onMarkerClick } = options;
  if (!map || !window.ymaps3 || !Array.isArray(points)) return [];

  const created = [];
  points.forEach((p) => {
    const lat = Number(p.lat ?? p.latitude ?? 0);
    const lng = Number(p.lng ?? p.longitude ?? p.lon ?? 0);
    const driverId = p.driver_id ?? p.DriverID ?? null;

    const el = document.createElement('div');
    el.style.width = '66px';
    el.style.height = '92px';
    el.style.position = 'relative';
    el.style.transform = 'translate(-50%, -100%)';
    el.style.pointerEvents = interactive ? 'auto' : 'none';
    el.style.cursor = 'pointer';
    el.innerHTML = `
      <svg width="68" height="92" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="position:absolute;left:0;top:0;width:100%;height:100%;">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#ffffff" stroke="#000000" stroke-width="0.7"/>
      </svg>
      ${carIconSrc ? `<img src="${carIconSrc}" alt="car" style="position:absolute;left:50%;top:36%;width:34px;height:34px;transform:translate(-50%,-50%);object-fit:contain;padding:4px;" />` : ''}
    `;

    if (interactive && onMarkerClick && driverId) {
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        onMarkerClick(driverId);
      });
    }

    const marker = new window.ymaps3.YMapMarker(
      { coordinates: [lng, lat], draggable: false, mapFollowsOnDrag: false, zIndex: 500 },
      el
    );
    map.addChild(marker);
    created.push(marker);
  });
  return created;
}

export default drawPoints;